import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UrlParserTextArea } from 'shared/components/ui/url-parser';
import { useDelayedCallback } from 'shared/hooks/use-delayed-callback';

import * as Styled from './task-description.style';

export type TaskDescriptionProps = {
  description?: string | null;
  updateDescription: (description: string) => void;
  instantUpdate?: boolean;
};

export const TaskDescription: React.FC<TaskDescriptionProps> = ({
  description,
  updateDescription,
  instantUpdate,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(description ?? '');
  const [delayedOnChange, killOnChangeDelay] = useDelayedCallback(
    updateDescription,
    500,
  );

  const onChange = (value: string) => {
    setValue(value);

    if (instantUpdate) {
      updateDescription(value);
      return;
    }

    delayedOnChange(value);
  };

  const onBlur = () => {
    killOnChangeDelay();

    if (value === description) {
      return;
    }

    updateDescription(value);
  };

  return (
    <UrlParserTextArea
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      linkComponent={Styled.Anchor}
      placeholder={t('general.labels.task-detail.notes.placeholder')}
      variant="body2"
      respectNewLines
    />
  );
};
